<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-5">
        Rappel des coordonnées de l'organisateur :
      </div>
      <div class="col-7"></div>
    </div>
    <div class="row mb-3">
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="col-5 font-italic"
        style="white-space: pre-line;"
        v-html="pdfContactDetails"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pdfContactDetails"],
  data() {
    return {};
  },
};
</script>
